import { render, staticRenderFns } from "./EnableWalletForBulk.vue?vue&type=template&id=74d25078&"
import script from "./EnableWalletForBulk.vue?vue&type=script&lang=js&"
export * from "./EnableWalletForBulk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports